import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";
import { Box, CircularProgress } from "@mui/material";

import { Post } from "../../../Feeds/types/post.type";
import { ActivityType } from "../../../User/api/services/activities.service";
import { useUserActivities } from "../../../User/api/queries/useUserActivities";

import PostCard from "../../../Feeds/components/Posts";
import noActivities from "../../assets/images/empty-activities-figure.png";

const ActivitiesList = ({ userId, fullName }: { userId: string; fullName: string }) => {
  const { t } = useTranslation("profiles", {
    keyPrefix: "activity",
  });

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const activityType = (searchParams.get("activity") as ActivityType) || ActivityType.all;

  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } = useUserActivities(userId, activityType);

  const { ref, inView } = useInView();
  const posts = data?.posts || [];

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage, isFetchingNextPage]);

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (posts.length === 0) {
    return (
      <Box
        sx={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", gap: "12px" }}
      >
        <img
          src={noActivities}
          alt="no activities"
          style={{
            width: "82.308px",
            height: "65.132px",
          }}
        />
        {t("userHasNoActivities", { fullName })}
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      {posts.map((post: Post) => (
        <PostCard key={post.id} post={post} onClickOnMedia={() => {}} />
      ))}

      <Box ref={ref} sx={{ height: "fit-content", width: "100%" }}>
        {isFetchingNextPage && (
          <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
            <CircularProgress />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ActivitiesList;
